import { Dropdown } from "antd";
import { MoreOutlined } from "@ant-design/icons";
import { TClickAction } from "../dataTypes";
import { ActionButton } from "./ActionButton";

export interface ActionViewProps {
  actions: TClickAction[];
  maxVisible?: number;
  direction?: "horizontal" | "vertical";
  gap?: number;
  moreIcon?: React.ReactNode;
}

export const ActionView: React.FC<ActionViewProps> = ({
  actions,
  maxVisible = 3,
  direction = "horizontal",
  gap = 0,
  moreIcon,
}) => {
  const visibleActions = actions.slice(0, maxVisible);
  const overflowActions = actions.slice(maxVisible);

  const layoutClass =
    direction === "vertical"
      ? `flex flex-col items-center`
      : `flex flex-row items-center flex-wrap`;

  const moreButton = moreIcon ?? <MoreOutlined style={{ fontSize: 24, color: "#1890ff" }} />;

  return (
    <div className={layoutClass} style={{ gap }}>
      {visibleActions.map((btnConfig, index) => (
        <ActionButton key={index} config={btnConfig} />
      ))}

      {overflowActions.length > 0 && (
        <Dropdown
          menu={{
            items: overflowActions.map((action) => ({
              key: action.label,
              label: action.label,
              danger: action.danger,
              disabled: action.disabled,
              onClick: action.onClick,
            })),
          }}
          placement="bottomRight"
        >
          {moreButton}
        </Dropdown>
      )}
    </div>
  );
};
